import { useEffect } from "react";
import { PAYMENT_METHODS, type PaymentMethod } from "./paymentConfig";
import "./PaymentModal.scss";

type PaymentModalProps = {
  method: PaymentMethod | null;
  onClose: () => void;
};

function PaymentModal({ method, onClose }: PaymentModalProps) {
  useEffect(() => {
    if (!method) {
      return;
    }

    function handleEscape(e: KeyboardEvent) {
      if (e.key === "Escape") {
        onClose();
      }
    }

    window.addEventListener("keydown", handleEscape);
    return () => window.removeEventListener("keydown", handleEscape);
  }, [method, onClose]);

  if (!method) {
    return null;
  }

  const selectedPayment = PAYMENT_METHODS[method];

  return (
    <div
      className="payment-modal-overlay"
      onClick={onClose}
      role="button"
      tabIndex={0}
      aria-label="Close QR code modal"
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          onClose();
        }
      }}
    >
      <div
        className="payment-modal"
        role="dialog"
        aria-modal="true"
        aria-label={selectedPayment.alt}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          className="payment-modal__close"
          onClick={onClose}
          aria-label="Close modal"
        >
          ×
        </button>
        <h3 className="payment-modal__title">{selectedPayment.title}</h3>
        <p>{selectedPayment.detail}</p>
        <img
          src={selectedPayment.src}
          alt={selectedPayment.alt}
          className="payment-modal__img"
        />
      </div>
    </div>
  );
}

export default PaymentModal;
